import { ButtonBase, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import React from 'react'

import { gregorianToJalaali } from '../../../helpers/date'
import { getTranslate, lang } from '../../../localization'
import { Template } from '../../../types/contractTemplate'
import useStyles from './styles/index.styles'

interface TemplateTimeIntervalProps {
  index: number
  data: Template
  onDelete: (index: number) => void
}

const TemplateTimeInterval: React.FC<TemplateTimeIntervalProps> = ({
  index,
  onDelete,
  data
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <div className={classes.counter}>{index}</div>
      </div>
      <div>
        <Tooltip
          placement={lang === 'fa' ? 'right' : 'left'}
          title={
            <div>
              {lang === 'fa'
                ? gregorianToJalaali(data.From) +
                  ' => ' +
                  gregorianToJalaali(data.To)
                : data.From + ' => ' + data.To}
            </div>
          }>
          <div>
            {lang === 'fa'
              ? gregorianToJalaali(data.To) +
                ' <= ' +
                gregorianToJalaali(data.From)
              : data.From + ' => ' + data.To}
          </div>
        </Tooltip>
      </div>
      <div className={classes.weekdays}>
        {data.Weekdays.Saturday && <div>{getTranslate('Sat')}</div>}
        {data.Weekdays.Sunday && (
          <div>
            {data.Weekdays.Saturday && ','}&nbsp;{getTranslate('Sun')}
          </div>
        )}
        {data.Weekdays.Monday && (
          <div>
            {(data.Weekdays.Saturday || data.Weekdays.Sunday) && ','}&nbsp;
            {getTranslate('Mon')}
          </div>
        )}
        {data.Weekdays.Tuesday && (
          <div>
            {(data.Weekdays.Saturday ||
              data.Weekdays.Sunday ||
              data.Weekdays.Monday) &&
              ','}
            &nbsp;{getTranslate('Tues')}
          </div>
        )}
        {data.Weekdays.Wednesday && (
          <div>
            {(data.Weekdays.Saturday ||
              data.Weekdays.Sunday ||
              data.Weekdays.Monday ||
              data.Weekdays.Tuesday) &&
              ','}
            &nbsp;{getTranslate('Wed')}
          </div>
        )}
        {data.Weekdays.Thursday && (
          <div>
            {(data.Weekdays.Saturday ||
              data.Weekdays.Sunday ||
              data.Weekdays.Monday ||
              data.Weekdays.Tuesday ||
              data.Weekdays.Wednesday) &&
              ','}
            &nbsp;{getTranslate('Thu')}
          </div>
        )}
        {data.Weekdays.Friday && (
          <div>
            {(data.Weekdays.Saturday ||
              data.Weekdays.Sunday ||
              data.Weekdays.Monday ||
              data.Weekdays.Tuesday ||
              data.Weekdays.Wednesday ||
              data.Weekdays.Thursday) &&
              ','}
            &nbsp;{getTranslate('Fri')}
          </div>
        )}
      </div>
      <div>
        {data.CurrencyDiscounts.map((cd) => (
          <div>
            {`${cd.Currency}: `}
            {cd.DiscountPercent}
          </div>
        ))}
      </div>
      <div className={classes.RestrictionsContainer}>
        {!!data.Restrictions.CTA && (
          <div>
            {getTranslate('CTA: ')}{' '}
            {data.Restrictions.CTA
              ? getTranslate('True')
              : getTranslate('False')}
          </div>
        )}
        {!!data.Restrictions.CTD && (
          <div>
            {getTranslate('CTD: ')}{' '}
            {data.Restrictions.CTD
              ? getTranslate('True')
              : getTranslate('False')}
          </div>
        )}
        {!!data.Restrictions.MinStay && (
          <div>{getTranslate('MinStay: ') + data.Restrictions.MinStay}</div>
        )}
        {!!data.Restrictions.MaxStay && (
          <div>{getTranslate('MaxStay: ') + data.Restrictions.MaxStay}</div>
        )}
        {!!data.Restrictions.Status && (
          <div>
            {getTranslate('Status: ')}{' '}
            {data.Restrictions.Status
              ? getTranslate('Open')
              : getTranslate('Closed')}
          </div>
        )}
      </div>
      <div>
        <ButtonBase onClick={() => onDelete(index - 1)}>
          <DeleteIcon />
        </ButtonBase>
      </div>
    </div>
  )
}

export default TemplateTimeInterval
